<template>
  <div>
    <b-card>
      <b-card-title>
        <b-row>
          <b-col md="6" cols="12">
            Tipos de Acuerdos Laborales
          </b-col>
          <b-col md="6" cols="12" class="d-flex justify-content-end">
            <b-button variant="primary" @click="openModal('create')" size="sm">
              <feather-icon icon="PlusIcon" class="mr-50" />
              <span class="align-middle">Agregar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-title>

      <b-row class="mb-2">
        <b-col md="4" cols="12">
          <b-input-group size="sm">
            <b-form-input
              v-model="filters.search_txt"
              placeholder="Buscar..."
              @keyup.enter="refreshGrid"
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="outline-primary" @click="refreshGrid">
                <feather-icon icon="SearchIcon" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table
        ref="refListTable"
        :items="myProvider"
        :fields="fields"
        responsive
        hover
        show-empty
        empty-text="No records found"
        :per-page="perPage"
        :current-page="currentPage"
        :busy.sync="isBusy"
        small
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Cargando...</strong>
          </div>
        </template>

        <template #cell(modo_calculo)="data">
          <b-badge variant="light-primary">
            {{ etiquetaModo(data.value) }}
          </b-badge>
          <span
            v-if="data.value === 'ciclo' && data.item.dias_trabajo"
            class="ml-50"
            style="opacity: 0.7"
          >
            {{ data.item.dias_trabajo }} x {{ data.item.dias_descanso }}
          </span>
        </template>

        <template #cell(registrado_por_nombre)="data">
          <span>{{ data.value || '-' }}</span>
        </template>

        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item @click="openModal('edit', data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Editar</span>
            </b-dropdown-item>
            <b-dropdown-item @click="deleteItem(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Eliminar</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.of }} entries</span>
          </b-col>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <AddTipoAcuerdoModal
      v-if="showModal"
      :method="modalMethod"
      :item="selectedItem"
      @close="closeModal"
      @saved="onSaved"
    />
  </div>
</template>

<script>
import TiposAcuerdosService from "./service/tipos-acuerdos.service.js";
import AddTipoAcuerdoModal from "./AddTipoAcuerdoModal.vue";

export default {
  components: {
    AddTipoAcuerdoModal,
  },
  data() {
    return {
      fields: [
        { key: "id", label: "ID" },
        { key: "nombre", label: "Nombre" },
        { key: "descripcion", label: "Descripción" },
        { key: "dias_libres_mensuales", label: "Días Libres" },
        { key: "modo_calculo", label: "Cálculo" },
        { key: "registrado_por_nombre", label: "Registrado por" },
        { key: "actions", label: "Actions" },
      ],
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pagination: {
        from: 0,
        to: 0,
        of: 0,
      },
      filters: {
        search_txt: "",
      },
      showModal: false,
      modalMethod: "create",
      selectedItem: null,
    };
  },
  methods: {
    etiquetaModo(modo) {
      const etiquetas = {
        fijo: "FIJO",
        domingos_mes: "DOMINGOS DEL MES",
        ciclo: "POR CICLO",
      };
      return etiquetas[modo] || "FIJO";
    },
    refreshGrid() {
      if (this.$refs.refListTable) {
        this.$refs.refListTable.refresh();
      }
    },
    openModal(method, item = null) {
      this.modalMethod = method;
      this.selectedItem = item;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.selectedItem = null;
    },
    onSaved() {
      this.closeModal();
      this.refreshGrid();
    },
    async deleteItem(id) {
      try {
        const { isConfirmed } = await this.showConfirmSwal();
        if (!isConfirmed) return;

        this.addPreloader();
        const data = await TiposAcuerdosService.delete({ id });
        this.showToastSuccess(data.message);
        this.refreshGrid();
      } catch (error) {
        console.error(error);
        this.showToastError(error?.response?.data?.message || error.message);
      } finally {
        this.removePreloader();
      }
    },
    async myProvider(ctx) {
      try {
        this.isBusy = true;
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          search_txt: this.filters.search_txt,
        };

        const { data, total, to, from } = await TiposAcuerdosService.list(params);

        this.totalRows = total;
        this.pagination.of = total;
        this.pagination.to = to;
        this.pagination.from = from;

        return data;
      } catch (error) {
        console.error("Error loading table", error);
        return [];
      } finally {
        this.isBusy = false;
      }
    },
  },
};
</script>
